export default __webpack_public_path__ + "static/media/SwatiBhargava_Cofounder_CashKaro.802a319f.jpg";